<nf-grid-wrapper [hideSearch]="true" [hideClearAll]="true">
  <nf-grid-wrapper-content>
    <span>
      <nf-table-layout
        [hideTitle]="true"
        [gridOptions]="gridOptions"
        [autoResizeGrid]="false"
        [data]="ruleApplied"
        hideSearch
        hideClearAll
        *nfLoader="isRuleAppliedLoading"
      >
      </nf-table-layout>
    </span>
  </nf-grid-wrapper-content>
</nf-grid-wrapper>
